// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationBiomethaneSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.12 19.289c0-2.104-2.994-6.451-4.414-8.396a.892.892 0 0 0-1.463 0c-1.42 1.945-4.415 6.292-4.415 8.396 0 .297.027.588.078.871-1.624-1.373-2.651-3.395-2.651-5.65 0-3.033 4.151-8.345 6.365-10.963a1.747 1.747 0 0 1 2.708 0c2.214 2.618 6.365 7.93 6.365 10.964 0 2.254-1.026 4.276-2.65 5.649.05-.283.078-.574.078-.871zM11.974 22a7.975 7.975 0 0 1-1.742-.191c-.915-.554-1.474-1.523-1.474-2.52 0-.112.06-.475.335-1.14.254-.617.625-1.332 1.063-2.086a43.03 43.03 0 0 1 1.818-2.83c.58.837 1.24 1.834 1.819 2.83.438.754.808 1.47 1.063 2.087.275.664.335 1.027.335 1.139 0 .997-.56 1.965-1.474 2.52a7.971 7.971 0 0 1-1.743.191z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavigationBiomethaneSolid;
